"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.classic = exports.novoDark = exports.novo = void 0;
const novo_1 = __importDefault(require("./novo/novo"));
const novoDark_1 = __importDefault(require("./novo/novoDark"));
const novoColorPalette_1 = __importDefault(require("./novo/novoColorPalette"));
const neoLight_1 = __importDefault(require("./novo/neoLight"));
const neoDark_1 = __importDefault(require("./novo/neoDark"));
// Deprecated exports — keep for backwards compatibility
// These are deprecated as they export the theme itself together with the values (colors) used by the theme
var novo_2 = require("./novo");
Object.defineProperty(exports, "novo", { enumerable: true, get: function () { return __importDefault(novo_2).default; } });
var novo_3 = require("./novo");
Object.defineProperty(exports, "novoDark", { enumerable: true, get: function () { return novo_3.dark; } });
var classic_1 = require("./classic");
Object.defineProperty(exports, "classic", { enumerable: true, get: function () { return __importDefault(classic_1).default; } });
const themes = {
    /** @deprecated use OxygenProvider (& light theme) */
    novo: novo_1.default,
    /** @deprecated use OxygenProvider (& dark theme) */
    novoDark: novoDark_1.default,
    /** @deprecated use colorPalette */
    novoColorPalette: novoColorPalette_1.default,
    light: novo_1.default,
    dark: novoDark_1.default,
    colorPalette: novoColorPalette_1.default,
    neoLight: neoLight_1.default,
    neoDark: neoDark_1.default,
};
// Direct theme exports on the default object
exports.default = themes;
